module.exports = __webpack_public_path__ + "img/bil2.883d17e8.jpg";